import mermaid from "mermaid";
import { useEffect, useRef } from "react";

export default function Visalization({ chart }:{chart:any}) {
    const mermaidRef = useRef(null);
    const customConfig = {
        theme: 'dark' as 'dark', // Use the dark base theme as a starting point
        themeVariables: {
            primaryColor: '#808080', // Gray for nodes
            primaryTextColor: '#ffffff', // White text
            secondaryColor: '#808080', // Gray for secondary nodes
            tertiaryColor: '#808080', // Gray for accents
            edgeLabelBackground: '#808080', // White background for edge labels
            lineColor: '#808080', // Gray lines for edges
            fontFamily: 'Arial, sans-serif', // Optional: Custom font
            background: '#2b2b2b', // Dark background for the diagram
        },
    };

    useEffect(() => {
        if (chart) {
            mermaid.initialize(customConfig);
            mermaid.contentLoaded();
        }
    }, [chart]);

    return (
        <div style={{ width: '100%' ,display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div
            ref={mermaidRef}
            className="mermaid"
            style={{ width: '100%', height: '100%' }}
            dangerouslySetInnerHTML={{ __html: chart }}
            ></div>
        </div>
    )

}